declare let self: ServiceWorkerGlobalScope;

const getSWRegistration = async (): Promise<ServiceWorkerRegistration> => {
    return self.registration;
};

export default getSWRegistration;
